import React, { useState } from "react";
import "../styles/Savings.css";
import {
    FaUniversity,
    FaUsers,
    FaShieldAlt,
    FaHandHoldingUsd,
    FaPiggyBank,
    FaBriefcase
} from "react-icons/fa";

function Savings() {

    const [active, setActive] = useState("");

    return (

        <div className="account-container">
            <h1 className="page-title">Open an Account with Us</h1>
            <p className="page-subtitle">Choose the account that suits your needs</p>

            <p className="intro-text">
                At Sahyadri Sahakari Bank, we make banking simple, secure, and customer-friendly.
                Whether you are saving for your future or running a business, our accounts are
                designed to give you flexibility, safety, and personalized service.
            </p>

            <div className="account-cards-wrapper">
                <div className="account-cards">

                    {/* SAVINGS CARD */}
                    <div className="account-card">
                        <FaPiggyBank size={50} color="#e3730b" />
                        <h2>Savings Account</h2>
                        <p>Ideal for individuals to save money and earn interest.</p>
                        <button onClick={() => setActive("savings")}>Know More</button>
                    </div>

                    {/* CURRENT CARD */}
                    <div className="account-card">
                        <FaBriefcase size={50} color="#e3730b" />
                        <h2>Current Account</h2>
                        <p>Best for businesses with frequent transactions.</p>
                        <button onClick={() => setActive("current")}>Know More</button>
                    </div>

                </div>
            </div>

            {active === "savings" && (
                <div className="account-info">
                    <h3>Savings Account Details</h3>

                    <p>
                        A Savings Account at Sahyadri Sahakari Bank is designed to help individuals
                        safely store money while earning attractive interest on deposits. Our savings
                        accounts provide easy access to funds, passbook facility, ATM services, and
                        personalized banking support.

                        To open a savings account, visit your nearest branch, fill out the account
                        opening form, attach required KYC documents such as Aadhaar, PAN, and address
                        proof, submit passport-size photographs, and deposit the minimum opening
                        balance. Our staff will assist you throughout the process.

                        Once your account is active, you can start saving, withdraw money when needed,
                        and enjoy secure banking services. This account is perfect for salaried
                        individuals, students, homemakers, and senior citizens.
                    </p>

                    <a href="/forms/savings-form.pdf" download>
                        Download Savings Account Form
                    </a>
                </div>
            )}

            {active === "current" && (
                <div className="account-info">
                    <h3>Current Account Details</h3>

                    <p>
                        A Current Account is suitable for business owners, traders, and organizations
                        that require frequent deposits and withdrawals. Sahyadri Sahakari Bank offers
                        flexible current accounts with higher transaction limits and efficient
                        banking support.

                        To open a current account, please visit the branch with business registration
                        documents, identity proofs, photographs, and opening deposit. Our banking
                        executives will guide you through the formalities and activate your account
                        quickly.

                        This account helps businesses manage daily finances smoothly while enjoying
                        reliable local banking service and personalized assistance.
                    </p>

                    <a href="/forms/current-form.pdf" download>
                        Download Current Account Form
                    </a>
                </div>
            )}

            <div className="why-us">

                <h2>Why Choose Sahyadri Bank?</h2>

                <div className="why-cards">

                    <div className="why-card">
                        <FaUniversity size={32} />
                        <h4>Trusted Banking</h4>
                        <p>Years of reliable cooperative banking service.</p>
                    </div>

                    <div className="why-card">
                        <FaUsers size={32} />
                        <h4>Personal Support</h4>
                        <p>Friendly staff and customer-focused service.</p>
                    </div>

                    <div className="why-card">
                        <FaShieldAlt size={32} />
                        <h4>Secure Funds</h4>
                        <p>Your deposits are safe and protected.</p>
                    </div>

                    <div className="why-card">
                        <FaHandHoldingUsd size={32} />
                        <h4>Easy Process</h4>
                        <p>Simple account opening and guidance.</p>
                    </div>

                </div>

            </div>

        </div>
    );
}

export default Savings;
